import ContactGroups from 'collections/contactGroups';

export default new ContactGroups();
